<template>
  <div class="container-fluid m-0 p-0" v-if="user">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex justify-content-between align-items-center"
            >
              <h6 class="text-white text-capitalize ps-3 mb-0">Carteira</h6>
            </div>
          </div>

          <div class="card-body p-4 p-md-4 p-sm-3 px-2">
            <!-- Balance Section -->
            <div class="row mb-4">
              <div class="col-lg-6 col-md-12 mb-4 mb-lg-0">
                <div
                  class="card shadow-lg h-100"
                  style="background: linear-gradient(195deg, #661cb0, #5a189a)"
                >
                  <div class="card-body p-4 p-sm-3 position-relative">
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <div
                        class="bg-white shadow-sm border-radius-xl"
                        style="
                          width: 64px;
                          height: 64px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          border-radius: 12px;
                        "
                      >
                        <i
                          class="material-icons text-dark"
                          style="font-size: 32px; line-height: 1"
                          >account_balance_wallet</i
                        >
                      </div>
                      <span class="badge badge-sm bg-gradient-success"
                        >Ativo</span
                      >
                    </div>

                    <p
                      class="text-white text-sm mb-0 font-weight-bold opacity-8"
                    >
                      Saldo Disponível
                    </p>
                    <h2 class="text-white font-weight-bolder mb-3">
                      {{ formatCurrency(balance) }}
                    </h2>

                      <div
                        class="d-flex flex-wrap align-items-center gap-2 mt-auto"
                      >
                        <span
                          class="badge badge-sm bg-secondary text-white border-0 opacity-8"
                          >Mínimo: R$ 100,00</span
                        >
                        <span
                          class="badge badge-sm bg-secondary text-white border-0 opacity-8"
                          >Máximo: R$ 3.000,00</span
                        >
                        <span
                          class="badge badge-sm bg-secondary text-white border-0 opacity-8"
                          >Taxa saque: R$ 4,50</span
                        >
                        <span
                          class="badge badge-sm bg-info text-white border-0"
                          >Regra: 1 Saque por Semana</span
                        >
                      </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-12">
                <div class="card h-100 border-1 shadow-sm">
                  <div class="card-body p-4">
                    <h6 class="mb-1 text-dark font-weight-bold">
                      Solicitar Saque
                    </h6>
                    <p class="text-xs text-muted mb-3">
                      Transfira seu saldo para sua conta bancária via Pix.
                    </p>

                    <div class="bg-gradient-warning text-white rounded p-3 mb-4 d-flex shadow-sm align-items-center">
                      <i class="material-icons text-white me-2" style="font-size: 24px;">warning</i>
                      <span class="text-sm font-weight-bold" style="line-height: 1.4;">
                        A chave PIX deve ser de uma conta do mesmo titular (com o mesmo CPF/CNPJ do cadastro). Caso não seja, o saque será negado. Cada solicitação da Carteira do Sistema fica entre R$ 100,00 e R$ 3.000,00.
                      </span>
                    </div>

                    <div class="withdrawal-deadline-notice mb-4">
                      <i class="material-icons">schedule</i>
                      <div>
                        <strong>Prazo de processamento: até 48 horas úteis</strong>
                        <span>
                          Após a solicitação, o valor será analisado e enviado para a conta Pix informada dentro desse prazo.
                        </span>
                      </div>
                    </div>

                    <div v-if="currentWeekActiveWithdrawal" class="alert alert-info text-white border-0">
                      <div class="d-flex align-items-center mb-2">
                        <i class="material-icons me-2">info</i>
                        <span class="font-weight-bold text-md">Limite Semanal Atingido</span>
                      </div>
                      <span class="text-sm d-block mb-0" v-if="currentWeekActiveWithdrawal.status === 'PENDING'">
                        Voce tem um saque pendente nesta semana, aguarde a aprovação para realizar outro na próxima semana.
                      </span>
                      <span class="text-sm d-block mb-0" v-else-if="currentWeekActiveWithdrawal.status === 'PAID'">
                        Você já realizou um saque essa semana. Você poderá solicitar um novo saque no dia {{ nextAvailableWithdrawalDate }}.
                      </span>
                    </div>

                    <div class="d-flex flex-column gap-3" v-else-if="balance >= minimumWithdrawalAmount">
                      <DefaultInput
                        v-model="withdrawalReceiverName"
                        label="Nome do recebedor"
                        placeholder="Nome completo"
                        required
                      />

                      <div class="row m-0 p-0">
                        <div class="col-md-5 ps-0 pe-md-2 mb-3 mb-md-0">
                          <DefaultSelect
                            v-model="withdrawalPixType"
                            label="Tipo de PIX"
                            :options="pixTypeOptions"
                            placeholder="Tipo"
                            required
                          />
                        </div>
                        <div class="col-md-7 px-0 mb-3 mb-md-0">
                          <DefaultInput
                            :modelValue="withdrawalPixKey"
                            @update:modelValue="onPixKeyInput"
                            label="Chave Pix"
                            placeholder="Digite a chave"
                            required
                          />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <DefaultInput
                            v-model="withdrawalAmount"
                            label="Valor do Saque"
                            placeholder="R$ 0,00"
                            type="number"
                            :min="minimumWithdrawalAmount"
                            :max="Math.min(balance, maximumWithdrawalAmount)"
                            @input="verifyAmount"
                          />
                          <small class="text-muted text-xs ms-1 d-block">
                            Limite por solicitação: de
                            {{ formatCurrency(minimumWithdrawalAmount) }} até
                            {{ formatCurrency(maximumWithdrawalAmount) }}.
                          </small>
                          <small class="text-muted text-xs ms-1"
                            >Valor a receber:
                            {{
                              withdrawalAmount > 4.5
                                ? formatCurrency(withdrawalAmount - 4.5)
                                : "R$ 0,00"
                            }}</small
                          >
                        </div>
                      </div>

                      <div class="text-end mt-2">
                        <DefaultButton
                          :label="'Confirmar Saque'"
                          :buttonColor="'#661cb0'"
                          :textColor="'#ffffff'"
                          :disabled="
                            loadingWithdrawAL ||
                            withdrawalAmount < minimumWithdrawalAmount ||
                            withdrawalAmount > maximumWithdrawalAmount
                          "
                          @confirm="handleWithdrawal"
                          class="w-100"
                        />
                      </div>
                      <p class="text-center text-xs text-muted mb-0 mt-2">
                        <i class="material-icons text-xs align-middle me-1"
                          >schedule</i
                        >
                        O prazo começa a contar após o envio da solicitação.
                      </p>
                    </div>

                    <div
                      v-else
                      class="d-flex flex-column align-items-center justify-content-center py-4 opacity-7"
                    >
                      <i class="material-icons text-4xl text-secondary mb-2"
                        >lock_clock</i
                      >
                      <p
                        class="text-secondary text-sm text-center mb-0 font-weight-bold"
                      >
                        Saldo insuficiente
                      </p>
                      <span class="text-xs text-muted text-center"
                        >Acumule {{ formatCurrency(minimumWithdrawalAmount) }} para sacar</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="vertical dark my-4" />

            <!-- Withdrawals History -->
            <h6 class="mb-3">Meus Saques</h6>
            <div class="table-responsive p-0 mb-4">
              <table
                class="table align-items-center mb-0"
                v-if="withdrawals.length > 0"
              >
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-start"
                    >
                      Data
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Valor
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Recebedor
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Tipo PIX
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Chave Pix
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="wd in withdrawals" :key="wd.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <span class="text-sm font-weight-bold">{{
                          formatDate(wd.created_at)
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span class="text-sm font-weight-bold text-dark">{{
                        formatCurrency(wd.amount)
                      }}</span>
                    </td>
                    <td>
                      <span class="text-sm text-secondary">{{
                        wd.name || "-"
                      }}</span>
                    </td>
                    <td>
                      <span class="text-xs text-secondary">{{
                        wd.pix_type || "-"
                      }}</span>
                    </td>
                    <td>
                      <span class="text-sm text-secondary">{{
                        wd.pix_key
                      }}</span>
                    </td>
                    <td>
                      <div class="d-flex flex-column align-items-center">
                        <span
                          class="badge badge-sm"
                          :class="{
                            'bg-gradient-success': wd.status === 'PAID',
                            'bg-gradient-warning': wd.status === 'PENDING',
                            'bg-gradient-danger': wd.status === 'REJECTED',
                          }"
                        >
                          {{ translateStatus(wd.status) }}
                        </span>
                        <span
                          v-if="wd.status === 'REJECTED' && wd.rejection_reason"
                          class="badge badge-sm bg-gradient-danger mt-2"
                          style="cursor: pointer; opacity: 0.8;"
                          @click="showRejectionReason(wd.rejection_reason)"
                        >
                          <i class="material-icons text-xxs align-middle me-1">info</i>
                          Ver Motivo
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Paginator
                v-if="withdrawalsPages > 1"
                v-model:first="currentWithdrawalsPage"
                :rows="1"
                :totalRecords="withdrawalsPages"
                @page="onWithdrawalsPageChange"
              />
              <div v-else-if="withdrawals.length === 0" class="text-center py-3">
                <span class="text-secondary text-sm"
                  >Nenhum saque solicitado.</span
                >
              </div>
            </div>

            <hr class="vertical dark my-4" />

            <!-- Transactions History -->
            <h6 class="mb-3">Histórico de Transações</h6>
            
            <div class="row px-0 mb-3 align-items-end">
              <div class="col-12">
                <label class="input-label w-100 mb-0">
                  <span
                    class="text-xs text-uppercase text-body font-weight-bolder"
                  >
                    Pesquisar transação
                  </span>
                  <div class="d-flex align-items-center position-relative">
                    <input
                      v-model="searchTerm"
                      @input="debounceSearch"
                      @keyup.enter="performSearch"
                      type="text"
                      class="form-control"
                      style="border: 1px solid #d2d6da; border-radius: 0.375rem; padding: 0.5rem 0.75rem; background-color: #fff; width: 100%;"
                      placeholder="Digite a descrição da transação..."
                    />
                    <i
                      class="material-icons position-absolute end-0 me-3"
                      style="color: #adb5bd"
                      >search</i
                    >
                  </div>
                </label>
              </div>
            </div>

            <div class="table-responsive p-0">
              <table
                class="table align-items-center mb-0"
                v-if="transactions.length > 0 && !isSearchingTransactions"
              >
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-start"
                    >
                      Data
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Descrição
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Valor
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      Tipo
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="tx in transactions" :key="tx.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <span class="text-sm font-weight-bold">{{
                          formatDate(tx.created_at)
                        }}</span>
                      </div>
                    </td>
                    <td>
                      <span class="text-sm text-secondary font-weight-bold">{{
                        tx.description
                      }}</span>
                    </td>
                    <td>
                      <span
                        class="text-sm font-weight-bold"
                        :class="tx.type === 'CREDIT' ? 'text-success' : 'text-danger'"
                      >
                        {{ tx.type === 'CREDIT' ? '' : '-' }}{{ formatCurrency(Math.abs(tx.amount)) }}
                      </span>
                    </td>
                    <td>
                      <span class="text-xs font-weight-bold mb-0">{{
                        translateTransactionType(tx.type)
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Paginator
                v-if="pages > 1 && !isSearchingTransactions"
                v-model:first="currentPage"
                :rows="1"
                :totalRecords="pages"
                @page="onPageChange"
              />
              <div v-if="isSearchingTransactions" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Carregando...</span>
                </div>
                <p class="text-sm text-secondary mt-2">Buscando transações...</p>
              </div>
              <div v-else-if="transactions.length === 0" class="text-center py-3">
                <span class="text-secondary text-sm"
                  >Nenhuma transação encontrada.</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading" />

    <!-- Modal Informativo -->
    <WalletInfoModal ref="walletInfoModal" @activate="showActivationModal" />

    <!-- Modal de Ativação -->
    <WalletActivationModal
      ref="walletActivationModal"
      @confirm="handleActivateWallet"
    />

    <!-- Modal Nova Regra de Saques -->
    <WithdrawalRuleModal ref="withdrawalRuleModal" @close="onWithdrawalRuleClosed" />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import DefaultInput from "@/components/DefaultInput.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import WalletInfoModal from "@/components/WalletInfoModal.vue";
import WalletActivationModal from "@/components/WalletActivationModal.vue";
import WithdrawalRuleModal from "@/components/WithdrawalRuleModal.vue";
import WalletHttp from "@/http/WalletHttp.js";
import UsersHttp from "@/http/UsersHttp.js";
import LoggingMixin from "@/mixins/LoggingMixin";
import DefaultSelect from "@/components/DefaultSelect.vue";
import { Paginator } from "primevue";

export default {
  name: "wallet",
  mixins: [LoggingMixin],
  components: {
    Loading,
    DefaultInput,
    DefaultButton,
    DefaultSelect,
    WalletInfoModal,
    WalletActivationModal,
    WithdrawalRuleModal,
    Paginator,
  },
  data() {
    return {
      user: null,
      loading: true,
      balance: 0.0,
      transactions: [],
      withdrawals: [],
      withdrawalAmount: "",
      withdrawalPixKey: "",
      withdrawalPixType: "",
      withdrawalReceiverName: "",
      loadingWithdrawAL: false,
      minimumWithdrawalAmount: 100,
      maximumWithdrawalAmount: 3000,
      pixTypeOptions: [
        { label: "CPF", value: "CPF" },
        { label: "CNPJ", value: "CNPJ" },
        { label: "Celular", value: "Celular" },
        { label: "Email", value: "Email" },
        { label: "Chave Aleatória", value: "Chave Aleatória" },
      ],
      pages: 0,
      currentPage: 0,
      searchTerm: "",
      searchTimeout: null,
      withdrawalsPages: 1,
      currentWithdrawalsPage: 0,
      isSearchingTransactions: false,
    };
  },
  computed: {
    currentWeekActiveWithdrawal() {
      if (!this.withdrawals || this.withdrawals.length === 0) return null;

      const now = new Date();
      // Ajuste para encontrar o Domingo desta semana como início
      const startOfWeek = new Date(now);
      startOfWeek.setDate(now.getDate() - now.getDay());
      startOfWeek.setHours(0, 0, 0, 0);

      // Fim da semana é Sábado
      const endOfWeek = new Date(now);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);

      return this.withdrawals.find(w => {
        const d = new Date(w.created_at);
        return d >= startOfWeek && d <= endOfWeek && (w.status === 'PENDING' || w.status === 'PAID');
      });
    },
    nextAvailableWithdrawalDate() {
      const now = new Date();
      const nextSunday = new Date(now);
      nextSunday.setDate(now.getDate() + (7 - now.getDay()));
      return nextSunday.toLocaleDateString("pt-BR");
    }
  },
  async mounted() {
    this.user = this.$store.getters.user;
    await this.init();

    if (this.user && this.user.system_wallet) {
      // Show withdrawal rule modal if not seen
      if (!localStorage.getItem("seen_withdrawal_rule_3000")) {
        setTimeout(() => {
          this.$refs.withdrawalRuleModal.show();
        }, 800);
      }
    }
  },
  beforeUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  },
  methods: {
    onWithdrawalRuleClosed() {
      localStorage.setItem("seen_withdrawal_rule_3000", "true");
    },
    showRejectionReason(reason) {
      this.$toast.add({
        severity: "error",
        summary: "Motivo da Rejeição",
        detail: reason,
        life: 8000,
      });
    },
    async init() {
      this.loading = true;
      try {
        await Promise.all([
          this.getBalance(),
          this.getHistory(),
          this.getWithdrawals(),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getBalance() {
      try {
        const response = await WalletHttp.getWalletBalance();
        this.balance = response.data.balance;
      } catch (error) {
        console.error(error);
      }
    },
    async getHistory(page = 1) {
      try {
        const response = await WalletHttp.getWalletHistory(page, this.searchTerm.trim(), 10);
        this.transactions = response.data.transactions || [];
        this.pages = response.data.pages || 0;
        this.currentPage = (response.data.page || 1) - 1;
      } catch (error) {
        console.error(error);
      } finally {
        this.isSearchingTransactions = false;
      }
    },
    debounceSearch() {
      this.isSearchingTransactions = true;
      this.transactions = [];
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.performSearch();
      }, 500);
    },
    async performSearch() {
      this.currentPage = 0;
      await this.getHistory(1);
    },
    async onPageChange(event) {
      const page = event.page + 1;
      await this.getHistory(page);
    },
    async getWithdrawals(page = 1) {
      try {
        const response = await WalletHttp.getWithdrawals(page, 5);
        this.withdrawals = response.data.data || [];
        this.withdrawalsPages = Math.ceil((response.data.total || 0) / 5);
        this.currentWithdrawalsPage = page - 1;
      } catch (error) {
        console.error(error);
      }
    },
    async onWithdrawalsPageChange(event) {
      const page = event.page + 1;
      await this.getWithdrawals(page);
    },
    async handleWithdrawal() {
      if (!this.withdrawalPixKey) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Informe a chave Pix.",
          life: 3000,
        });
        return;
      }

      const amount = parseFloat(this.withdrawalAmount);
      if (!amount || amount < this.minimumWithdrawalAmount) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: `O valor mínimo é ${this.formatCurrency(this.minimumWithdrawalAmount)}.`,
          life: 3000,
        });
        return;
      }

      if (amount > this.maximumWithdrawalAmount) {
        this.$toast.add({
          severity: "warn",
          summary: "Limite por solicitação",
          detail: `O valor máximo por saque é ${this.formatCurrency(this.maximumWithdrawalAmount)}.`,
          life: 4000,
        });
        return;
      }

      if (amount > this.balance) {
        this.$toast.add({
          severity: "error",
          summary: "Saldo Insuficiente",
          detail: `Você tentou sacar ${this.formatCurrency(amount)}, mas seu saldo disponível é de ${this.formatCurrency(this.balance)}.`,
          life: 5000,
        });
        return;
      }

      this.loadingWithdrawAL = true;
      try {
        await WalletHttp.requestWithdrawal({
          amount: amount,
          pix_key: this.withdrawalPixKey,
          pix_type: this.withdrawalPixType,
          name: this.withdrawalReceiverName,
        });

        this.$toast.add({
          severity: "success",
          summary: "Sucesso",
          detail: "Solicitação de saque enviada!",
          life: 3000,
        });

        this.withdrawalAmount = "";
        this.withdrawalPixKey = "";
        this.withdrawalPixType = "";
        this.withdrawalReceiverName = "";
        await this.init(); // Refresh data
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: error.response?.data?.error || "Erro ao solicitar saque.",
          life: 3000,
        });
      } finally {
        this.loadingWithdrawAL = false;
      }
    },
    verifyAmount() {
      if (this.withdrawalAmount < 0) this.withdrawalAmount = 0;
      const allowedMaximum = Math.min(this.balance, this.maximumWithdrawalAmount);
      if (allowedMaximum > 0 && parseFloat(this.withdrawalAmount) > allowedMaximum) {
        this.withdrawalAmount = allowedMaximum;
      }
    },
    onPixKeyInput(value) {
      this.withdrawalPixKey = this.applyPixMask(value);
    },
    applyPixMask(value) {
      if (!this.withdrawalPixType) return value;

      const cleanValue = value.replace(/\D/g, "");

      if (this.withdrawalPixType === "CPF") {
        return cleanValue
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d)/, "$1.$2")
          .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
          .substring(0, 14);
      }

      if (this.withdrawalPixType === "CNPJ") {
        return cleanValue
          .replace(/^(\d{2})(\d)/, "$1.$2")
          .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
          .replace(/\.(\d{3})(\d)/, ".$1/$2")
          .replace(/(\d{4})(\d)/, "$1-$2")
          .substring(0, 18);
      }

      if (this.withdrawalPixType === "Celular") {
        return cleanValue
          .replace(/^(\d{2})(\d)/, "($1) $2")
          .replace(/(\d{5})(\d)/, "$1-$2")
          .substring(0, 15);
      }

      return value;
    },
    formatCurrency(value) {
      return value.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleString("pt-BR");
    },
    translateStatus(status) {
      switch (status) {
        case "PENDING":
          return "Pendente";
        case "PAID":
          return "Pago";
        case "REJECTED":
          return "Rejeitado";
        default:
          return status;
      }
    },
    translateTransactionType(type) {
      switch (type) {
        case "CREDIT":
          return "Crédito";
        case "DEBIT":
          return "Débito";
        case "WITHDRAWAL":
          return "Saque";
        default:
          return type;
      }
    },
    showActivationModal() {
      this.$refs.walletActivationModal.show();
    },
    async handleActivateWallet() {
      this.loading = true;
      try {
        // Atualizar objeto do usuário localmente e enviar para backend
        let updatedUser = { ...this.user };
        updatedUser.system_wallet = true;

        const response = await UsersHttp.updateProfile(updatedUser);
        this.user = response.data;

        this.$store.commit('setUser', this.user)

        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Carteira do Sistema ativada com sucesso.",
          life: 3000,
        });

        // Recarregar a página para atualizar
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity: "error",
          summary: "Erro!",
          detail: error.response?.data?.error || "Erro ao ativar carteira.",
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.withdrawal-deadline-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border: 1px solid rgba(102, 28, 176, 0.2);
  border-left: 4px solid #661cb0;
  border-radius: 0.5rem;
  background: rgba(102, 28, 176, 0.06);
  color: #3f215d;
}

.withdrawal-deadline-notice > i {
  margin-top: 0.05rem;
  color: #661cb0;
  font-size: 1.5rem;
}

.withdrawal-deadline-notice strong,
.withdrawal-deadline-notice span {
  display: block;
}

.withdrawal-deadline-notice strong {
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}

.withdrawal-deadline-notice span {
  color: #6d6277;
  font-size: 0.75rem;
  line-height: 1.45;
}

/* Responsividade Mobile */
@media (max-width: 768px) {
  /* Reduzir padding nos cards em mobile */
  .card-body {
    padding: 1rem !important;
  }

  /* Ajustar tamanho de fonte dos títulos */
  h2 {
    font-size: 1.5rem !important;
  }

  h6 {
    font-size: 0.95rem !important;
  }

  /* Melhorar espaçamento dos badges */
  .badge {
    font-size: 0.65rem !important;
    padding: 0.25rem 0.5rem !important;
  }

  /* Ajustar tabelas para scroll horizontal */
  .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table {
    min-width: 600px;
  }

  /* Reduzir padding das células da tabela */
  .table td,
  .table th {
    padding: 0.5rem !important;
    font-size: 0.75rem !important;
  }

  /* Ajustar espaçamento dos inputs */
  .form-control {
    font-size: 0.875rem;
  }

  /* Melhorar botões em mobile */
  .btn {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
  }
}

@media (max-width: 576px) {
  /* Extra small devices */
  .card-body {
    padding: 0.75rem !important;
  }

  h2 {
    font-size: 1.25rem !important;
  }

  .table {
    font-size: 0.7rem !important;
  }

  .badge {
    font-size: 0.6rem !important;
  }
}
</style>
